// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<polygon points="16 9.05 9.05 9.05 9.05 16 6.95 16 6.95 9.05 0 9.05
				0 6.95 6.95 6.95 6.95 0 9.05 0 9.05 6.95 16 6.95" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Plus.js